import { Login } from "../../features/auth/domain/usecases/Login";
import { Logout } from "../../features/auth/domain/usecases/Logout";
import { Renew } from "../../features/auth/domain/usecases/Renew";
import { SendOtp } from "../../features/auth/domain/usecases/SendOtp";
import { AuthRepositoryImpl } from "../../features/auth/data/repositories/AuthRepositoryImpl";
import { AuthDataSourceImpl } from "../../features/auth/data/datasource/AuthDataSource";
import { LoginGmail } from "../../features/auth/domain/usecases/LoginGmail";
import { RemoveAccount } from "../../features/auth/domain/usecases/RemoveAccount";
import { UpdateUser } from "../../features/profile/domain/usecases/updateUser";
import { CheckSignupPhotoLiveness } from "../../features/profile/domain/usecases/checkSignupPhotoLiveness";
import { SaveSignupPhotoLivenessResult } from "../../features/profile/domain/usecases/saveSignupPhotoLivenessResult";
import { GetCategories } from "../../features/profile/domain/usecases/getCategories";
import { GetUser } from "../../features/profile/domain/usecases/getUser";
import { SendProfileConfig } from "../../features/profile/domain/usecases/sendProfileConfig";
import { OnboardingRepositoryImpl } from "../../features/profile/data/repositories/OnboardingRepositoryImpl";
import { OnboardingDataSourceImpl } from "../../features/profile/data/datasource/OnboardingDataSource";
import { GetProfileConfig } from "../../features/profile/domain/usecases/getProfileConfig";
import { SettingsDataSourceImpl } from "../../features/settings/data/datasource/SettingsDataSource";
import { SettingsRepositoryImpl } from "../../features/settings/data/repositories/SettingsRepositoryImpl";
import { GetVerificationCode } from "../../features/settings/domain/usecases/getVerificationCode";
import { SendVerificationPhotoConfig } from "../../features/settings/domain/usecases/sendVerificationPhoto";
import { CreateVerificationLivenessSession } from "../../features/settings/domain/usecases/createVerificationLivenessSession";
import { SaveVerificationLivenessResult } from "../../features/settings/domain/usecases/saveVerificationLivenessResult";
import { CreateAdminLiveFaceSession } from "../../features/settings/domain/usecases/createAdminLiveFaceSession";
import { SaveAdminLiveFaceResult } from "../../features/settings/domain/usecases/saveAdminLiveFaceResult";
import { GetPlaces } from "../../features/settings/domain/usecases/getPlaces";
import { GetDetailsPlace } from "../../features/settings/domain/usecases/getDetailsPlace";
import { MatchDataSourceImpl } from "../../features/match/data/datasource/MatchDataSource";
import { MatchRepositoryImpl } from "../../features/match/data/repositories/MatchRepositoryImpl";
import { GetMatchSearch } from "../../features/match/domain/usecases/getMatchSearch";
import { GetLikes } from "../../features/match/domain/usecases/getLikes";
import { DeleteLike } from "../../features/match/domain/usecases/deleteLike";
import { GetReportSubject } from "../../features/match/domain/usecases/getReportSubject";
import { RejectMatch } from "../../features/match/domain/usecases/rejectMatch";
import { ConnectSocketMatch } from "../../features/match/domain/usecases/connectSocket";
import { MatchSocketDataSourceImpl } from "../../features/match/data/datasource/MatchSocketDataSource";
import { MatchRepositorySocketImpl } from "../../features/match/data/repositories/MatchSocketRepositoryImpl";
import { DisconnectSocketMatch } from "../../features/match/domain/usecases/disconnectSocket";
import { EmitLike } from "../../features/match/domain/usecases/emitLike";
import { OnNotificationLike } from "../../features/match/domain/usecases/notificationLike";
import { PartnerSocketDataSourceImpl } from "../../features/settings/data/datasource/PartnerSocketDataSource";
import { PartnerSocketRepositoryImpl } from "../../features/settings/data/repositories/PartnerSocketRepositoryImpl";
import { DisconnectPartnerSocket } from "../../features/settings/domain/usecases/DisconnectPartnerSocket";
import { ConnectPartnerSocket } from "../../features/settings/domain/usecases/ConnectPartnerSocket";
import { GetNotificationsPartner } from "../../features/settings/domain/usecases/getNotificationsPartner";
import { GetPendingPartners } from "../../features/settings/domain/usecases/getPendingPartners";
import { ResponseInvitation } from "../../features/settings/domain/usecases/responseInvitation";
import { SendInvitationPartner } from "../../features/settings/domain/usecases/sendInvitationPartner";
import { DeleteCurrentPartner } from "../../features/settings/domain/usecases/deleteCurrentPartner";
import { GetMyMatches } from "../../features/match/domain/usecases/getMyMatches";
import { GetMyLikes } from "../../features/match/domain/usecases/getMyLikes";
import { ChatDataSourceImpl } from "../../features/chat/data/datasource/ChatDataSource";
import { ChatSocketDataSourceImpl } from "../../features/chat/data/datasource/ChatSocketDataSource";
import { ChatRepositoryImpl } from "../../features/chat/data/repositories/ChatRepositoryImpl";
import { ChatRepositorySocketImpl } from "../../features/chat/data/repositories/ChatSocketRepositoryImpl";
import { GetChats } from "../../features/chat/domain/usecases/getChat";
import { GetMessages } from "../../features/chat/domain/usecases/getMessages";
import { ConnectSocketChat } from "../../features/chat/domain/usecases/connectSocket";
import { ChatDisconnectSocket } from "../../features/chat/domain/usecases/disconnectSocket";
import { AddMessage } from "../../features/chat/domain/usecases/addMessage";
import { OnNewMessage } from "../../features/chat/domain/usecases/onNewMessage";
import { UpdateMessageRead } from "../../features/chat/domain/usecases/updateMessageRead";
import { OnUpdateMessage } from "../../features/chat/domain/usecases/onUpdateMessage";
import { EmitTempMessage } from "../../features/chat/domain/usecases/emitTempMessage";
import { OnTempMessageSeen } from "../../features/chat/domain/usecases/onTempMessageSeen";
import { GetMyNewMatches } from "../../features/match/domain/usecases/getMyNewMatches";
import { ListenPartnerInvited } from "../../features/settings/domain/usecases/onPartnerInvited";
import { CancelInvitationPartner } from "../../features/settings/domain/usecases/CancelInvitationPartner";
import { GetNotificationsPartnerResponse } from "../../features/settings/domain/usecases/getNotificationsPartnerResponse";
import { SubscriptionsDataSourceImpl } from "../../features/subscriptions/data/datasource/SubscriptionsDataSource";
import { SubscriptionsRepositoryImpl } from "../../features/subscriptions/data/repositories/SubscriptionsRepositoryImpl";
import { GetSubscriptionAll } from "../../features/subscriptions/domain/usecases/getSubscriptionAll";
import { CreateOrderPaypal } from "../../features/match/domain/usecases/createOrderPaypal";
import { SendPaidMessage } from "../../features/match/domain/usecases/sendPaidMessage";
import { CreateSubscriptionWithPaypal } from "../../features/subscriptions/domain/usecases/createSubscriptionWithPaypal";
import { GetSubscriptionByUser } from "../../features/subscriptions/domain/usecases/getSubscriptionByUser";
import { CancelSubscriptionWithPaypal } from "../../features/subscriptions/domain/usecases/cancelSubscriptionWithPaypal";
import { GetUserInfoById } from "../../features/match/domain/usecases/getUserInfoById";
import { RequestRemoveAccount } from "../../features/auth/domain/usecases/RequestRemoveAccount";
import { SetPassword } from "../../features/auth/domain/usecases/SetPassword";
import { AdminDataSourceImpl } from "../../features/admin/data/datasource/AdminDataSource";
import { AdminRepositoryImpl } from "../../features/admin/data/repositories/AdminRepositoryImpl";
import { GetVideos } from "../../features/admin/domain/usecases/getVideos";
import { NotificationDataSourceImpl } from "../../features/notification/data/datasource/NotificationDataSource";
import { GetNotification } from "../../features/notification/domain/usecases/getPlaces";
import { NotificationRepositoryImpl } from "../../features/notification/data/repositories/NotificationDataSourceRepositoryImpl";
import { OnNotificationAlert } from "../../features/admin/domain/usecases/onNotificationAlert";
import { SendNewTicket } from "../../features/profile/domain/usecases/sendNewTicket";
import { OnUpdatedChatStatus } from "../../features/chat/domain/usecases/onUpdatedChatStatus";
import { UpdateChatStatus } from "../../features/chat/domain/usecases/updateChatStatus";
import { ClearChat } from "../../features/chat/domain/usecases/clearChat";
import { GetReferralCode } from "../../features/profile/domain/usecases/getReferralCode";
import { DeleteTrashUser } from "../../features/match/domain/usecases/deleteTrashUser";
import { AdminSocketDataSourceImpl } from "../../features/admin/data/datasource/AdminSocketDataSource";
import { AdminRepositorySocketImpl } from "../../features/admin/data/repositories/AdminSocketRepositoryImpl";
import { ConnectSocketAdmin } from "../../features/admin/domain/usecases/connectSocket";
import { AdminDisconnectSocket } from "../../features/admin/domain/usecases/disconnectSocket";
import { DeleteNotification } from "../../features/notification/domain/usecases/deleteNotification";
import { NotificationSocketDataSourceImpl } from "../../features/notification/data/datasource/NotificationSocketDataSource";
import { NotificationRepositorySocketImpl } from "../../features/notification/data/repositories/NotificationSocketRepositoryImpl";
import { OnPurchaseMessageNotification } from "../../features/notification/domain/usecases/onPurchaseMessageNotification";
import { ConnectSocketNotification } from "../../features/notification/domain/usecases/connectSocket";
import { NotificationDisconnectSocket } from "../../features/notification/domain/usecases/disconnectSocket";
import { DeleteBlockMatch } from "../../features/match/domain/usecases/deleteBlockMatch";
import { UploadFile } from "../../features/chat/domain/usecases/uploadFile";

//DataSources
const authDataSource = new AuthDataSourceImpl();
const onboardingDataSource = new OnboardingDataSourceImpl();
const settingsgDataSource = new SettingsDataSourceImpl();
const matchDataSource = new MatchDataSourceImpl();
const matchSocketDataSource = new MatchSocketDataSourceImpl();
const partnerSocketDataSource = new PartnerSocketDataSourceImpl();
const chatDataSource = new ChatDataSourceImpl();
const chatSocketDataSource = new ChatSocketDataSourceImpl();
const subscriptionsDataSource = new SubscriptionsDataSourceImpl();
const adminDataSource = new AdminDataSourceImpl();
const adminSocketDataSource = new AdminSocketDataSourceImpl();
const notificationDataSource = new NotificationDataSourceImpl();
const notificationSocketDataSource = new NotificationSocketDataSourceImpl();

//Repositories
const authRepository = new AuthRepositoryImpl(authDataSource);
const profileRepository = new OnboardingRepositoryImpl(onboardingDataSource);
const settingsRepository = new SettingsRepositoryImpl(settingsgDataSource);
const matchRepository = new MatchRepositoryImpl(matchDataSource);
const matchSocketRepository = new MatchRepositorySocketImpl(
  matchSocketDataSource,
);
const partnerSocketRepository = new PartnerSocketRepositoryImpl(
  partnerSocketDataSource,
);
const chatRepository = new ChatRepositoryImpl(chatDataSource);
const chatSocketRepository = new ChatRepositorySocketImpl(chatSocketDataSource);
const subscriptionsRepository = new SubscriptionsRepositoryImpl(
  subscriptionsDataSource,
);
const adminRepository = new AdminRepositoryImpl(adminDataSource);
const adminSocketRepository = new AdminRepositorySocketImpl(
  adminSocketDataSource,
);
const notificationRepository = new NotificationRepositoryImpl(
  notificationDataSource,
);
const notificationSocketRepository = new NotificationRepositorySocketImpl(
  notificationSocketDataSource,
);

//Usecases
const loginUseCase = new Login(authRepository);
const sendOtp = new SendOtp(authRepository);
const logout = new Logout(authRepository);
const renew = new Renew(authRepository);
const loginGmail = new LoginGmail(authRepository);
const removeAccount = new RemoveAccount(authRepository);
const requestRemoveAccount = new RequestRemoveAccount(authRepository);
const setPassword = new SetPassword(authRepository);
const getUser = new GetUser(profileRepository);
const updateUser = new UpdateUser(profileRepository);
const checkSignupPhotoLiveness = new CheckSignupPhotoLiveness(
  profileRepository,
);
const saveSignupPhotoLivenessResult = new SaveSignupPhotoLivenessResult(
  profileRepository,
);
const getCategories = new GetCategories(profileRepository);
const sendProfileConfig = new SendProfileConfig(profileRepository);
const getProfileConfig = new GetProfileConfig(profileRepository);
const sendNewTicket = new SendNewTicket(profileRepository);
const getReferralCode = new GetReferralCode(profileRepository);
const getVerificationCode = new GetVerificationCode(settingsRepository);
const getPlaces = new GetPlaces(settingsRepository);
const getDetailsPlace = new GetDetailsPlace(settingsRepository);
const sendVerificationPhoto = new SendVerificationPhotoConfig(
  settingsRepository,
);
const createVerificationLivenessSession = new CreateVerificationLivenessSession(
  settingsRepository,
);
const saveVerificationLivenessResult = new SaveVerificationLivenessResult(
  settingsRepository,
);
const createAdminLiveFaceSession = new CreateAdminLiveFaceSession(
  settingsRepository,
);
const saveAdminLiveFaceResult = new SaveAdminLiveFaceResult(settingsRepository);
const getMatchSearch = new GetMatchSearch(matchRepository);
const getLikes = new GetLikes(matchRepository);
const getMyLikes = new GetMyLikes(matchRepository);
const getMyMatches = new GetMyMatches(matchRepository);
const getMyNewMatches = new GetMyNewMatches(matchRepository);
const deleteTrashUser = new DeleteTrashUser(matchRepository);
const deleteBlockMatch = new DeleteBlockMatch(matchRepository);
const deleteLike = new DeleteLike(matchRepository);
const getReportSubject = new GetReportSubject(matchRepository);
const rejectMatch = new RejectMatch(matchRepository);
const connectSocket = new ConnectSocketMatch(matchSocketRepository);
const disconnectSocket = new DisconnectSocketMatch(matchSocketRepository);
const emitLike = new EmitLike(matchSocketRepository);
const onNotificationLike = new OnNotificationLike(matchSocketRepository);
const getChats = new GetChats(chatRepository);
const getMessages = new GetMessages(chatRepository);
const clearChat = new ClearChat(chatRepository);
const uploadFile = new UploadFile(chatRepository);
const connectSocketChat = new ConnectSocketChat(chatSocketRepository);
const chatDisconnectSocket = new ChatDisconnectSocket(chatSocketRepository);
const addMessage = new AddMessage(chatSocketRepository);
const onNewMessage = new OnNewMessage(chatSocketRepository);
const updateMessageRead = new UpdateMessageRead(chatSocketRepository);
const onUpdateMessage = new OnUpdateMessage(chatSocketRepository);
const emitTempMessage = new EmitTempMessage(chatSocketRepository);
const getSubscriptionAll = new GetSubscriptionAll(subscriptionsRepository);
const createSubscriptionWithPaypal = new CreateSubscriptionWithPaypal(
  subscriptionsRepository,
);
const getSubscriptionByUser = new GetSubscriptionByUser(
  subscriptionsRepository,
);
const cancelSubscriptionWithPaypal = new CancelSubscriptionWithPaypal(
  subscriptionsRepository,
);
const createOrderPaypal = new CreateOrderPaypal(matchRepository);
const sendPaidMessage = new SendPaidMessage(matchRepository);
const getUserInfoById = new GetUserInfoById(matchRepository);
const onTempMessageSeen = new OnTempMessageSeen(chatSocketRepository);
const getVideos = new GetVideos(adminRepository);
const getNotification = new GetNotification(notificationRepository);
const deleteNotification = new DeleteNotification(notificationRepository);
const onNotificationAlert = new OnNotificationAlert(adminSocketRepository);
const connectSocketAdmin = new ConnectSocketAdmin(adminSocketRepository);
const adminDisconnectSocket = new AdminDisconnectSocket(adminSocketRepository);
const onUpdatedChatStatus = new OnUpdatedChatStatus(chatSocketRepository);
const updateChatStatus = new UpdateChatStatus(chatSocketRepository);
const onPurchaseMessageNotification = new OnPurchaseMessageNotification(
  notificationSocketRepository,
);
const connectSocketNotification = new ConnectSocketNotification(
  notificationSocketRepository,
);
const notificationDisconnectSocket = new NotificationDisconnectSocket(
  notificationSocketRepository,
);

const connectPartnerSocket = new ConnectPartnerSocket(partnerSocketRepository);
const partnerDisconnectSocket = new DisconnectPartnerSocket(
  partnerSocketRepository,
);

const getPendingPartners = new GetPendingPartners(partnerSocketRepository);
const getAddPartner = new GetPendingPartners(partnerSocketRepository);
const cancelPartner = new CancelInvitationPartner(partnerSocketRepository);
const deleteCurrentPartner = new DeleteCurrentPartner(partnerSocketRepository);
const emitPartnerRequest = new SendInvitationPartner(partnerSocketRepository);
const onEmitPartnerResponse = new ResponseInvitation(partnerSocketRepository);

const getNotificationsPartner = new GetNotificationsPartner(
  partnerSocketRepository,
);

const getNotificationsPartnerResponse = new GetNotificationsPartnerResponse(
  partnerSocketRepository,
);

const listenPartnerInvited = new ListenPartnerInvited(partnerSocketRepository);

const injection = {
  loginUseCase,
  sendOtp,
  renew,
  logout,
  loginGmail,
  removeAccount,
  requestRemoveAccount,
  setPassword,
  getUser,
  updateUser,
  checkSignupPhotoLiveness,
  saveSignupPhotoLivenessResult,
  getCategories,
  sendProfileConfig,
  getProfileConfig,
  getVerificationCode,
  getPlaces,
  getDetailsPlace,
  sendVerificationPhoto,
  createVerificationLivenessSession,
  saveVerificationLivenessResult,
  createAdminLiveFaceSession,
  saveAdminLiveFaceResult,
  getMatchSearch,
  getLikes,
  getMyLikes,
  getMyMatches,
  getMyNewMatches,
  deleteLike,
  getReportSubject,
  rejectMatch,
  connectSocket,
  disconnectSocket,
  emitLike,
  onNotificationLike,
  deleteCurrentPartner,
  cancelPartner,
  getPendingPartners,
  getAddPartner,
  partnerDisconnectSocket,
  connectPartnerSocket,
  getNotificationsPartner,
  getNotificationsPartnerResponse,
  listenPartnerInvited,
  emitPartnerRequest,
  onEmitPartnerResponse,
  getChats,
  getMessages,
  connectSocketChat,
  chatDisconnectSocket,
  addMessage,
  onNewMessage,
  updateMessageRead,
  onUpdateMessage,
  emitTempMessage,
  getSubscriptionAll,
  createOrderPaypal,
  sendPaidMessage,
  onTempMessageSeen,
  createSubscriptionWithPaypal,
  getSubscriptionByUser,
  cancelSubscriptionWithPaypal,
  getUserInfoById,
  getVideos,
  getNotification,
  onNotificationAlert,
  sendNewTicket,
  onUpdatedChatStatus,
  updateChatStatus,
  clearChat,
  getReferralCode,
  deleteTrashUser,
  connectSocketAdmin,
  adminDisconnectSocket,
  deleteNotification,
  connectSocketNotification,
  notificationDisconnectSocket,
  onPurchaseMessageNotification,
  deleteBlockMatch,
  uploadFile,
};

export default injection;
